<template>
  <div class="page-wrapper">
    <v-col cols="12" lg="10" md="7">
      <v-form>
        <v-card class="card-shadow bg-secondary">
          <LeituraOperadora />
        </v-card>
      </v-form>
    </v-col>
  </div>
</template>



<script>
import LeituraOperadora from "../Components/Leituras/LeituraOperadora.vue";
export default {
  name: "ReadOperator",
  components: {
    LeituraOperadora,
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
.page-wrapper {
  display: flex;
  justify-content: center;
}
</style>